import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert,
  Tooltip,
  Modal,
  Tabs,
  Tab,
  Checkbox,
  InputGroup,
  Image
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import "../../../style/subAdmin/SubAdmin.scss";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import { merchantActions } from "../../../redux/actions/merchantActions";
import DatePicker from "react-date-picker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import { alertsActions } from "../../../redux/actions/alertsActions";
import loader from "../../../style/loader/loader.scss";
import auth from "../../../services/auth";
import NumberFormat from "react-number-format";
import ReactAutocomplete from "react-autocomplete";
import ColorPicker from "rc-color-picker";
import {aclUtil} from "../../util"

let merchantID = "",
xCoordinate = {},
yCoordinate = {};
const history = createBrowserHistory();
const HorizontalLine = ({}) => <hr />;

const propTypes = {
  countries: PropTypes.array.isRequired
};

let isLoading = "false", colidxx="",
  userinfo = "";
let runOnce = false;
class StorefrontMerchant extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);

    this.state = {
      menuKey: 'ADD_MERCHANT',
      path: ["Home", "Manage Merchants", "Add New"],
      links:["home", "merchantList", "addMerchant"],
      merchantID: "",
      featuredOffer: "",
      storefrontUrl: "",
      replaceMainSiteLogo: "0",
      featuredOfferError: "",   
      merchantName: "",
      storefrontUrlError: "",  
      siteDomain:location.protocol + '//' + location.host, 
      alertMessage: "",
      msgType: "success",
      coloridx: "0",
      colorManager: [],
      counter: 0,
      show: false,
      disabled: false,
      logomerchantId:'',
      showLogoPopup:false,
      src:'',
      merchant_logo:'',
    };

    this.handlecolorManagerSubmit = this.handlecolorManagerSubmit.bind(
      this
    );
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear = this.Clear.bind(this);
    this.handleAddLogo =this.handleAddLogo.bind(this);
    this.LogoClosePopup = this.LogoClosePopup.bind(this);
    this.handleLogoData = this.handleLogoData.bind(this);
    this.UploadLogo = this.UploadLogo.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleMerchantAssetType = idx => evt => {
    this.setState({ disabled: false });
    const newcolorManager = this.state.colorManager.map(
      (colManager, pidx) => {
        if (idx !== pidx) return colManager;
        return { ...colManager, merchantAssetType: evt.target.value, optionIdx: idx };
      }
    );
    this.setState({ colorManager: newcolorManager });
  };

  handleOptionName = idx => evt => {
    this.setState({ disabled: false });
    const newcolorManager = this.state.colorManager.map(
      (colManager, pidx) => {
        if (idx !== pidx) return colManager;
        return { ...colManager, optionName: evt.target.value };
      }
    );
    this.setState({ colorManager: newcolorManager });
  };

  handleBackgroundColorChange = idx => evt => {
    this.setState({ disabled: false });
    const newcolorManager = this.state.colorManager.map(
      (colManager, pidx) => {
        if (idx !== pidx) return colManager;
        return { ...colManager, backgroundColor: evt.target.value };
      }
    );

    this.setState({ colorManager: newcolorManager });
    let phyLoc = this.state.colorManager;
    if (phyLoc[idx].BackgroundColorError !== "") {
      phyLoc[idx].BackgroundColorError = "";
      this.setState({ colorManager: phyLoc });
    }
  };

  handleColorChange = idx => evt => {
    this.setState({ disabled: false });
    const newcolorManager = this.state.colorManager.map(
      (colManager, pidx) => {
        if (idx !== pidx) return colManager;
        return { ...colManager, backgroundColor: evt.color };
      }
    );

    this.setState({ colorManager: newcolorManager });
    let phyLoc = this.state.colorManager;
    if (phyLoc[idx].BackgroundColorError !== "") {
      phyLoc[idx].BackgroundColorError = "";
      this.setState({ colorManager: phyLoc });
    }
  };

  //Add Color Manager
  handleAddColorManager = idx => {
    this.setState({ disabled: false });
    this.setState({
      colorManager: this.state.colorManager.concat([
        {
          backgroundColor: "#26B99A",
          backgroundColorError: "",
          merchantAssetType: "header",
        }
      ])
    });
  };

  //Remove Color Manager
  handleRemoveColorManager = idx => () => {
    this.setState({ disabled: false });
    if (
      this.state.merchantID !== "" &&
      typeof this.state.colorManager[idx].colorID != "undefined"
    ) {
      const colorIDParam = this.state.colorManager[idx].colorID;
      const merchantIDParams = this.state.merchantID;
      this.props.dispatch(
        merchantActions.delete_merchant_store(merchantIDParams, colorIDParam)
      );
    }
    this.setState({
      colorManager: this.state.colorManager.filter(
        (p, pidx) => idx !== pidx
      )
    });
  };

  // Handle input onchange
  handleChange(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
    this.setState({ disabled: false });   
  }

  handleCheck(e) {
    if (e.target.checked == true) {
      this.setState({ [e.target.name]: 1 });
    } else {
      this.setState({ [e.target.name]: 0 });
    }
    this.setState({ disabled: false });
  }

  handleAddLogo(e) { 
    let data = e.target.attributes.getNamedItem('data-key').value;
    this.setState({
      logomerchantId: data,
      showLogoPopup: true,
    });
  }

  LogoClosePopup(e) { 
    this.setState({
      logomerchantId: '',
      showLogoPopup: false,
    });
  }

  UploadLogo(e) {
    const formData = new FormData(); 
    this.setState({ 
      isLoading: true
    });
    var reader = new FileReader();
    var url = reader.readAsDataURL(this.state.src);
    reader.onloadend = function (e) {
      this.setState({merchant_logo: reader.result});
    }.bind(this); 
    formData.append("merchantID", this.state.merchantID);
    formData.append("file", this.state.src); 
    this.props.dispatch(merchantActions.UploadLogo(formData));
  }

  handleLogoData(e) {
    let files = e.target.files;
    this.setState({src: files[0]}); 
  }

  handleValidation() {
    let formIsValid = true;
    this.state.storefrontUrlError = false;
    if (!this.state.storefrontUrl) {
      formIsValid = false;
      this.setState({
        storefrontUrlError: "red"
      });
    }
    return formIsValid;
  }

  componentWillUnmount() {
    this.props.dispatch(alertsActions.clearAlerts());
  }

  handleSubmit(e) {
    e.preventDefault();
    this.handleDismiss();
    if (this.handleValidation()) { 
      this.setState({ disabled: true });
      if (this.state.merchantID !== "") {
        const updateData = {
          merchantID: this.state.merchantID,
          featuredOffer: this.state.featuredOffer,
          merchantName: this.state.merchantName,
          storefrontUrl: this.state.storefrontUrl,
          replaceMainSiteLogo: this.state.replaceMainSiteLogo,
        };
        this.props.dispatch(merchantActions.update_merchant(updateData));
      }
    }
    else{
    let arr = Object.values(yCoordinate)
    let min = Math.min(...arr);
    let yCoordinateKey= '',yCoordinateValue, xCoordinateValue
    {Object.keys(yCoordinate).map((key) => {
      if(yCoordinate[key] === min && yCoordinateKey.length == 0){
        yCoordinateValue = yCoordinate[key]
        yCoordinateKey = key
      }
    })}
    if(yCoordinateKey.length > 0){
      xCoordinateValue = xCoordinate[yCoordinateKey]
      window.scrollTo(xCoordinateValue,yCoordinateValue)
    }
    }
  }
  Clear() {
      (this.state.merchantID = ""),
      (this.state.featuredOffer = ""),
      (this.state.storefrontUrl = ""),
      (this.state.replaceMainSiteLogo = "0"),
      (this.state.merchantName = ""),
      (this.state.colorManager = []),
      (this.state.counter = 0),
      (this.state.show = false),
      (this.state.disabled = false);
      colidxx="";
  }

  handlecolorManagerSubmit = merchantID => {
    let backgroundColor=[],
      merchantAssetType=[],
      optionName=[],
      colorID = [],
      LocationID = [];

    let colorManager = this.state.colorManager;
    this.state.colorManager.map(
      colManager => (
        colorID.push(colManager.colorID),
        backgroundColor.push(colManager.backgroundColor),
        merchantAssetType.push(colManager.merchantAssetType),
        optionName.push(colManager.optionName)
      )
    );

    const postData = {
      backgroundColor:backgroundColor,
      merchantAssetType:merchantAssetType,
      optionName:optionName,
      colorID: colorID,
    };
    this.props.dispatch(
      merchantActions.add_merchant_store(postData, merchantID)
    );
    colidxx="";
  };

  componentDidMount() {
    userinfo = auth.getUserInfo();
    this.handleDismiss();
    this.setState({ colorManager: [] });
    this.props.dispatch(alertsActions.clearAlerts());
    let userIdParams =
      this.props.match && this.props.match.params.userId
        ? this.props.match.params.userId
        : "";
    const editLink = this.props.match.params.userId && `addMerchant/${this.props.match.params.userId}`
    if (userIdParams && userIdParams !== "") {
      setTimeout((isLoading = "true"), 1000);
      this.props.dispatch(merchantActions.get_merchant(userIdParams));
      this.state.path = ["Home", "Manage Merchant", "Edit Merchant"];
      this.state.links = ["home", "merchantList", editLink];
    }

    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'))
    if (siteData.active_cities) {
      this.setState({
        cityList: siteData.active_cities,
      })
    }

    let siteDomain = (siteData.siteDomain ? siteData.siteDomain : ''); 
    this.setState({siteDomain: location.protocol + '//' + location.host});

    const { dispatch } = this.props;
  }

  componentWillReceiveProps(nextProps) { 
    let menuAclKey = this.state.menuKey;
    if(this.props.match && this.props.match.params.userId){
      menuAclKey = 'EDIT_MERCHANT';
    }
    if(!aclUtil.isPrimaryMenuAccessible(menuAclKey) && localStorage.getItem('userTypeName') !== 'merchant'){
      this.context.router.history.push("/restrictedAccess");
    }

    if (
      this.props.addMerchantResponse !== nextProps.addMerchantResponse &&
      !isEmpty(nextProps.addMerchantResponse)
    ) {
      const merchantID = (nextProps.addMerchantResponse.merchantID) ? nextProps.addMerchantResponse.merchantID : this.props.match.params.userId;
      this.handlecolorManagerSubmit(merchantID);
      this.onSelectedCountry();
      window.scrollTo(0, 0);
    }

    if (
      this.props.mrechantResponse !== nextProps.mrechantResponse &&
      !isEmpty(nextProps.mrechantResponse)
    ) {
      this.props.dispatch(alertsActions.clearAlerts());
      this.props.dispatch(
        alertsActions.renderAlerts(
          "success",
          nextProps.mrechantResponse.message
        )
      );
      this.Clear();
      isLoading = "false";
      this.setState({ disabled: false });
      window.scrollTo(0, 0);
    }

    if (
      this.props.updatedMerchant !== nextProps.updatedMerchant &&
      !isEmpty(nextProps.updatedMerchant)
    ) {
      this.handlecolorManagerSubmit(merchantID);
      this.props.dispatch(alertsActions.clearAlerts());
      this.handleShow();
      this.props.dispatch(
        alertsActions.renderAlerts("success", nextProps.updatedMerchant.message)
      );
      isLoading = "false";
      this.setState({ disabled: false });
      this.props.dispatch(merchantActions.get_merchant(this.state.merchantID));
      window.scrollTo(0, 0);
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.props.dispatch(alertsActions.clearAlerts());
        this.props.dispatch(
          alertsActions.renderAlerts("warning", nextProps.error)
        );
        isLoading = "false";
        window.scrollTo(0, 0);
      }
    }
    

    if(!isEmpty(nextProps.UploadLogo)) {
      if(nextProps.UploadLogo.response=="success")
      {
        this.setState({
          logomerchantId: '',
          showLogoPopup: false,
          isLoading: false,
          merchant_logo: nextProps.UploadLogo.data,
        });
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }

    if (
      this.props.merchantDetails !== nextProps.merchantDetails &&
      !isEmpty(nextProps.merchantDetails)
    ) {
      if (nextProps.merchantDetails) {
        let merchant = nextProps.merchantDetails;
        if (merchant !== "") {
          isLoading = false;
        }
        this.props.dispatch(
          merchantActions.get_merchant_store(merchant.merchant_id)
        );
        merchantID = merchant.merchant_id;
        this.setState({
          merchantID: merchant.merchant_id,  
          featuredOffer: merchant.featuredOffer, 
          merchantName: merchant.merchantName, 
          storefrontUrl: merchant.storefrontUrl,
          replaceMainSiteLogo: merchant.replaceMainSiteLogo,
          menuKey: 'EDIT_MERCHANT',
          merchant_logo: merchant.merchant_logo,
        });

      }
    }

    if (
      this.props.merchantStoreDetails !==
        nextProps.merchantStoreDetails &&
      !isEmpty(nextProps.merchantStoreDetails)
    ) {
      let editColorManager = [];
      let merchantstoreData = nextProps.merchantStoreDetails
        ? nextProps.merchantStoreDetails.data
        : [];
      if (merchantstoreData) {
        merchantstoreData.map((merchantStore, index) => {
          editColorManager.push({
            backgroundColor: merchantStore.backgroundColor,
            backgroundColorError: "",
            merchantAssetType: merchantStore.merchantAssetType,                    
            optionName: merchantStore.optionName,
            colorID: merchantStore.colorID,
          });
        });
      }
      this.setState({ colorManager: editColorManager });
    }

    if (
      this.props.deletedStoreresponse !==
        nextProps.deletedStoreresponse &&
      !isEmpty(nextProps.deletedStoreresponse)
    ) {
      this.props.dispatch(
        merchantActions.get_merchant_store(this.state.merchantID)
      );
      this.props.dispatch(alertsActions.clearAlerts());
      this.handleShow();
      this.props.dispatch(
        alertsActions.renderAlerts(
          "success",
          nextProps.deletedStoreresponse.message
        )
      );
      window.scrollTo(0, 0);
    }
    if (
      this.props.deleteLocationError !== nextProps.deleteLocationError &&
      !isEmpty(nextProps.deleteLocationError)
    ) {
      this.props.dispatch(alertsActions.clearAlerts());
      this.handleShow();
      this.props.dispatch(
        alertsActions.renderAlerts("warning", nextProps.deleteLocationError)
      );
      window.scrollTo(0, 0);
    }
  }

  handleMerchantStatus = (key) => {
    if(key === 1){
      this.props.history.push('/addMerchant/'+this.state.merchantID)
    }else if(key === 2){
      this.props.history.push('/storeMerchant/'+this.state.merchantID)
    }else{
      this.props.history.push('/addMerchant'+'/'+this.state.merchantID)
    }
  }

  render() {
    
    const { errmsg } = this.props;
    let replaceMainSiteLogoChecked = this.state.replaceMainSiteLogo == "1" ? "true" : "";
    let colidx = this.state.coloridx;

    return (
      <div className="col-lg-12 add-sub-admin">
        {this.props.error &&
        this.state.show &&
        this.state.alertMessage == "" ? (
          <div className="col-lg-12">
            <Alert
              bsStyle={this.props.error.msgType}
              onDismiss={this.handleDismiss}
            >
              <strong>{this.props.error.msgType}:</strong>{" "}
              {this.props.error.alertMessage}
            </Alert>
          </div>
        ) : isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <div>
          <form onSubmit={this.handleSubmit}>
            <div className="row">
              <div className="col-xs-12">
                <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
              </div>
            </div>
            {/**start merchant information **/}
            
            <Tabs activeKey={2} onSelect={this.handleMerchantStatus} id="controlled-tab-example">
              <Tab eventKey={1} title="Merchant Information">
              </Tab>
              <Tab eventKey={2} title="Storefront Design">
            
            <div className="panel">
              <header className="panel-heading">Storefront Design </header>

              {this.state.show &&
                this.state.alertMessage !== "" && (
                  <div className="col-lg-12">
                    <Alert
                      bsStyle={this.state.msgType}
                      onDismiss={this.handleDismiss}
                    >
                      <strong>{this.state.msgType}:</strong>{" "}
                      {this.state.alertMessage}
                    </Alert>
                  </div>
                )}
              <div className="panel-body">
                <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <Row>
                    <Col md={6} xs={12}>
                      <FormGroup controlId="formControlsFeaturedSelect">
                        <ControlLabel>Featured Offer</ControlLabel>
                        <FormControl
                          componentClass="select"
                          placeholder="select"
                          name="featuredOffer"
                          value={this.state.featuredOffer}
                          onChange={this.handleChange}
                        >
                          <option value="Enable">Enable</option>
                          <option value="Disable"> Disable </option>
                        </FormControl>
                      </FormGroup>
 
                    </Col>
                    <Col md={6} xs={12}>
                      <FormGroup controlId="formBasicstorefrontUrl"> 
                          <ControlLabel>Storefront URL (not include space or symbol)</ControlLabel>
                          <InputGroup>
                            <InputGroup.Addon>{this.state.siteDomain}/store/</InputGroup.Addon>
                            <FormControl 
                              type="text"
                              value={this.state.storefrontUrl}
                              name="storefrontUrl"
                              placeholder="Custom Page URL"
                              onChange={this.handleChange}
                              style={{ borderColor: this.state.storefrontUrlError }}
                            />
                          </InputGroup> 
                      </FormGroup>
                    </Col>
                    <Col md={6} xs={12}>
                        <FormGroup controlId="formBasicReplaceMainSiteLogo">
                          <ControlLabel>Replace the main site logo</ControlLabel>
                        </FormGroup>
                        <Checkbox
                          className="checkBox"
                          name="replaceMainSiteLogo"
                          checked={replaceMainSiteLogoChecked}
                          value={this.state.replaceMainSiteLogo}
                          onChange={this.handleCheck}
                          inline
                        >
                          Replace the main site logo with this logo on this merchant’s storefront page.
                        </Checkbox>
                    </Col>
                  </Row>                  
                </div>
              </div>
            </div>
            {this.state.merchantID ? ( 
              <div className="panel">
                <header className="panel-heading">Merchant Logo </header>
                <div className="panel-body">
                  <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <Row>
                      <Col md={4} xs={4}>
                      <Image src={this.state.merchant_logo} className="responsive" />
                      </Col>
                      <Col md={12} xs={12}>
                        <Button
                          type="button"
                          bsStyle="info"
                          onClick={this.handleAddLogo}
                          className="small"
                          data-key={this.state.merchantID}
                        >
                          Upload Logo
                        </Button>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div> 
              )
              : (
               ""
              )
            }
            {/**end merchant information **/}

            {/**start color manager **/}
            <div className="panel">
              <header className="panel-heading">Color Manager</header>
              <div className="panel-body">
                <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  {this.state.colorManager.map((colManager, idx) => (
                    <Row className="colManager" key={idx}>
                      <Col md={4} xs={12}>
                        <FormGroup controlId={`formBasicMerchantAssetType${idx}`}>
                          <ControlLabel>
                            Merchant Asset Type
                          </ControlLabel>
                          <FormControl
                            key={idx}
                            className="halfWidth"
                            componentClass="select"
                            name={`merchantAssetType${idx}`}
                            onChange={this.handleMerchantAssetType(idx)}
                            value={colManager.merchantAssetType}
                            >
                            <option value="header">Header</option>
                            <option value="button">Button</option>
                            <option value="menu_bar">Menu Bar</option>
                          </FormControl>
                        </FormGroup>
                      </Col>                      
                      {(colManager.merchantAssetType == "button") ?
                      <Col md={4} xs={12}>
                        <FormGroup controlId={`formBasicOptionName${idx}`}>
                          <ControlLabel>
                            Button Color
                          </ControlLabel>
                          <FormControl
                            key={idx}
                            className="halfWidth"
                            componentClass="select"
                            name={`optionName${idx}`}
                            onChange={this.handleOptionName(idx)}
                            value={colManager.optionName}
                            required="required"
                            >
                            <option value="">Select</option>
                            <option value="button_color">Button Color</option>
                            <option value="mouseover_color">Mouseover Color</option>
                          </FormControl>
                        </FormGroup> 
                        </Col>
                        : 
                        ''                        
                        }
                        {(colManager.merchantAssetType == "menu_bar") ?
                        <Col md={4} xs={12}>
                        <FormGroup controlId={`formBasicOptionName${idx}`}>
                          <ControlLabel>
                            Menu Bar
                          </ControlLabel>
                          <FormControl
                            key={idx}
                            className="halfWidth"
                            componentClass="select"
                            name={`optionName${idx}`}
                            onChange={this.handleOptionName(idx)}
                            value={colManager.optionName}
                            required="required"
                            >
                          <option value="">Select</option>
                          <option value="menu_bar_color">Menu Bar Color</option>
                          <option value="menu_bar_text">Menu Bar Text</option>
                          <option value="top_menu_bar">Top Menu Text</option>
                          </FormControl>
                        </FormGroup>  
                        </Col>                
                        : 
                        ''
                        }
                      
                      <Col md={4} xs={12}>
                        <ControlLabel>
                          Color (in hex code)
                        </ControlLabel>
                        <FormGroup
                          controlId={`formBasicBackgroundColor${idx}`}                          
                        >
                           <FormControl
                            key={idx}
                            type="text"
                            value={colManager.backgroundColor}
                            placeholder={`BackgroundColor`}
                            onChange={this.handleBackgroundColorChange(idx)}
                            name={`backgroundColor${idx}`}
                            required="required"
                          />
                          <ColorPicker
                          color={colManager.backgroundColor}
                          name={`backgroundColor${idx}`}
                          onChange={this.handleColorChange(idx)}
                          value={colManager.backgroundColor}
                        >
                          <span className="react-custom-trigger">Choose Color</span>
                        </ColorPicker>
                        </FormGroup>      
                      </Col>
                      <Col md={12} xs={12}>
                        <Button
                          type="button"
                          bsStyle="danger"
                          onClick={this.handleRemoveColorManager(idx)}
                          className="small"
                        >
                          Remove
                        </Button>
                        <HorizontalLine />
                      </Col>
                    </Row>
                  ))}
                  <Row>
                    <Col md={12} xs={12}>
                      <Button
                        type="button"
                        bsStyle="info"
                        onClick={this.handleAddColorManager}
                        className="small"
                      >
                        Add Color Manager
                      </Button>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
            {/**end physical location**/}

            <Row className="BtnRow">
              <Col md={12} xs={12}>
                <Button
                  bsStyle="info"
                  type="submit"
                  disabled={this.state.disabled}
                >
                  Save
                </Button>
                <Button
                  bsStyle="default"
                  onClick={() => (localStorage.getItem('userTypeName') == 'merchant') ? this.context.router.history.push(`/dashboard`) : this.context.router.history.push(`/merchantList`)}
                >
                  Cancel
                </Button>
              </Col>
            </Row>
            </Tab>
          </Tabs>
          </form>
        </div>

        <Modal show={this.state.showLogoPopup} onHide={this.LogoClosePopup}>
          <Modal.Header closeButton>
            <Modal.Title>Upload Logo</Modal.Title>
          </Modal.Header>
          <Modal.Body>
             <FormGroup>
                  <ControlLabel>Upload Merchant Logo</ControlLabel>
                  <FormControl
                    type="file"
                    id="file"
                    onChange={this.handleLogoData}
                  />
            </FormGroup>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="success" onClick={this.UploadLogo} disabled={this.state.isLoading===true ? true : false}>Upload</Button>
            <Button bsStyle="danger" onClick={this.LogoClosePopup}>Close</Button>
          </Modal.Footer>
        </Modal>

      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    addMerchantResponse: state.merchantReducer.addMerchantResponse,
    merchantDetails: state.merchantReducer.merchantDetails,
    merchantStoreDetails: state.merchantReducer.merchantStoreDetails,
    error: state.merchantReducer.error,
    sendingMerchant: state.merchantReducer.sendingMerchant,
    deletedStoreresponse: state.merchantReducer.deletedStoreresponse,
    requestingDeleteStore: state.merchantReducer.requestingDeleteStore,
    deleteLocationError: state.merchantReducer.deleteLocationError,
    errmsg: state.merchantReducer.errmsg,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    mrechantResponse: state.merchantReducer.mrechantResponse,
    updatedMerchant: state.merchantReducer.updatedMerchant,
    UploadLogo:state.merchantReducer.LogoDetail
  };
};

export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps)
)(StorefrontMerchant);



// WEBPACK FOOTER //
// ./src/app/views/admin/merchant/StoreMerchant.js